import { render, staticRenderFns } from "./tab-sms.vue?vue&type=template&id=2a928c92&"
import script from "./tab-sms.vue?vue&type=script&lang=js&"
export * from "./tab-sms.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports